<template>
  <div
    class="searchbar-user"
    :class="{'hotmart-pro': topBarConfig.user.ucode}"> 
    <div class="container no-padding">
      <div class="title">
        <svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" class="navbar-icon fa kp-panel-pop-up">
          <path d="M21.5 19.25V2.75C21.5 1.53125 20.4688 0.5 19.25 0.5H2.75C1.48438 0.5 0.5 1.53125 0.5 2.75V19.25C0.5 20.5156 1.48438 21.5 2.75 21.5H19.25C20.4688 21.5 21.5 20.5156 21.5 19.25ZM2.75 20C2.32812 20 2 19.6719 2 19.25V2.75C2 2.375 2.32812 2 2.75 2H19.25C19.625 2 20 2.375 20 2.75V19.25C20 19.6719 19.625 20 19.25 20H2.75ZM12.5 6.875V6.125C12.5 5.9375 12.3125 5.75 12.125 5.75H5.375C5.14062 5.75 5 5.9375 5 6.125V6.875C5 7.10938 5.14062 7.25 5.375 7.25H12.125C12.3125 7.25 12.5 7.10938 12.5 6.875ZM17 11.375V10.625C17 10.4375 16.8125 10.25 16.625 10.25H5.375C5.14062 10.25 5 10.4375 5 10.625V11.375C5 11.6094 5.14062 11.75 5.375 11.75H16.625C16.8125 11.75 17 11.6094 17 11.375ZM9.5 15.875V15.125C9.5 14.9375 9.3125 14.75 9.125 14.75H5.375C5.14062 14.75 5 14.9375 5 15.125V15.875C5 16.1094 5.14062 16.25 5.375 16.25H9.125C9.3125 16.25 9.5 16.1094 9.5 15.875Z"></path>
        </svg>
        {{ $t('index.title') }}
      </div>
      <div class="subtitle">
        {{ $t('index.subtitle') }}
      </div>
      <div class="search-flex">
        <label class="hide">
          <input type="text" name="q" :placeholder="$t('index.find_a_box')">
          <span class="filter_search icon-search">
            <i class="fa fa-search"></i>
            <i class="fa fa-times" klickart-folder-search-cancel=""></i>
          </span>
        </label>
        <div class="kp-filter-action">
          <a
            href="javascript:;"
            class="none-mobile pull-right kp-button"
            @click="boxAdd()">
            <span class="icon-kp-plus" aria-hidden="true"></span>{{ $t('general.actions.new') }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  computed: mapGetters({
    topBarConfig: 'topBar/config',
  }),
  methods: mapActions([
    'boxAdd',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** Search.vue?4a169204
 **/